import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import CallList from './CallList'
import { fetchCoredialCallsByPatient } from '../../../state/actions/call-log'

require('react-datepicker/dist/react-datepicker.css')

class Calls extends Component {
  componentDidMount() {
    const { patientId, fetchCallDataByPatientId, activeLocation } = this.props
    const locationId = activeLocation && activeLocation.id
    fetchCallDataByPatientId(patientId, locationId)
  }

  componentDidUpdate(prevProps) {
    const { activeLocation: prevLocation } = prevProps
    const {
      activeLocation,
      patientId,
      fetchCallDataByPatientId,
    } = this.props
    if (
      activeLocation
      && prevLocation
      && activeLocation.id !== prevLocation.id
    ) {
      fetchCallDataByPatientId(patientId, activeLocation.id)
    }
  }

  render() {
    const { isFetching, patientCallData } = this.props
    return (
      <div>
        <CallList
          allPatientCalls={patientCallData}
          isFetching={isFetching}
        />
      </div>
    )
  }
}

Calls.propTypes = {
  patientId: PropTypes.string.isRequired,
  fetchCallDataByPatientId: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  patientCallData: PropTypes.array.isRequired,
  activeLocation: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    additional_recipients: PropTypes.arrayOf(PropTypes.object),
    city: PropTypes.string,
    country_code: PropTypes.string,
    created_at: PropTypes.string,
    doctor_id: PropTypes.string,
    earliest_same_day_reminder_hour: PropTypes.number,
    facebook_url: PropTypes.string,
    forwarding_email: PropTypes.string,
    google_url: PropTypes.string,
    id: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    name: PropTypes.string,
    office_email: PropTypes.string,
    office_phone: PropTypes.string,
    phone_numbers: PropTypes.arrayOf(PropTypes.object),
    practice_id: PropTypes.number,
    state: PropTypes.string,
    street_address: PropTypes.string,
    timezone: PropTypes.string,
    updated_at: PropTypes.string,
    website: PropTypes.string,
    yelp_url: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
}

const mapStateToProps = ({
  callLog: { isFetching, patientCallData },
  account: { user: { activeLocation } },
}) => ({
  activeLocation,
  isFetching,
  patientCallData,
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    fetchCallDataByPatientId:
      (patientId, locationId) => fetchCoredialCallsByPatient(patientId, locationId),
  }, dispatch)
)


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Calls)



// WEBPACK FOOTER //
// ./src/components/PatientPage/Calls/index.js